import { useContext } from "react";
import { FormBuilderContext } from "../FormBuilderContext";
import InputActions from "../InputActions/InputActions";

import "./FormSection.less";

const FormSection = ({ item, onStartEdit, onDuplicate, onDelete }) => {
   const { previewMode } = useContext(FormBuilderContext);

   return (
      <div className="form-builder-section">
         <div className="form-builder-section-header">
            <div className="form-builder-section-title">{item.label}</div>
         </div>

         <InputActions onStartEdit={onStartEdit} onDuplicate={onDuplicate} onDelete={onDelete} />
      </div>
   );
};

export default FormSection;
